import { mdiEarth } from "@mdi/js";

const geoNav = [
  {
    title: "GEO Traffic List",
    icon: mdiEarth,
    to: "geo-traffic-list",
    resource: "geo_traffic_list",
    action: "manage",
  },
];

export default geoNav;

